import React, { useContext } from 'react'
import { months } from './helpers/constants'
import { Checkbox, Slider } from 'antd'
import { DataContext, StyleContext } from './GanttChart'
import { LeftOutlined, RightOutlined } from '@ant-design/icons'

const MonthRow = () => {
  const { startMonth, handleMonth } = useContext(DataContext)
  const { setColumnValue, setLockHeight } = useContext(StyleContext)

  const formatter = (value) => `${value}%`
  const onChange = (value) => {
    setColumnValue(value)
  }
  const onChangeCheckbox = (e) => {
    console.log(`checked = ${e.target.checked}`)
    setLockHeight(e.target.checked)
  }
  return (
    <div style={divCenter}>
      <div style={{ margin: '9px' }}>
        <Checkbox defaultChecked onChange={onChangeCheckbox}>
          Lock Height
        </Checkbox>
      </div>
      <div style={{ width: '100px', margin: '3px' }}>
        <Slider
          min={50}
          max={400}
          step={10}
          defaultValue={100}
          tooltip={{
            formatter
          }}
          onChange={onChange}
        />
      </div>

      <div style={divCenter1}>
        <button onClick={() => handleMonth('p')} style={buttonStyle}>
          <LeftOutlined />
        </button>
        <span style={vDividerStyle2}></span>
        <div style={ganttTimePeriodM}>
          <span style={ganttTimePeriodSpan}>
            {months[startMonth.getMonth()] + ' ' + startMonth.getFullYear()}
          </span>
        </div>
        <span style={vDividerStyle}></span>
        <button onClick={() => handleMonth('n')} style={buttonStyle}>
          <RightOutlined />
        </button>
      </div>
    </div>
  )
}

export default MonthRow
const vDividerStyle2 = {
  height: '24px',
  width: '1px',
  background: '#E1E5EE',
  margin: '9px 10px 0px 0px'
}

const vDividerStyle = {
  height: '24px',
  width: '1px',
  background: '#E1E5EE',
  margin: '9px 0px 0px 10px'
}
const buttonStyle = {
  padding: '12px 10px',
  cursor: 'pointer',
  border: 'none',
  marginTop:'0px',
    fontSize: '8px',
    background: 'transparent',
    color: '#8A93A7'

}


const ganttTimePeriodM = {
  display: 'grid',
  gridAutoFlow: 'column',
  gridAutoColumns: 'minmax(30px, 1fr)',
  textAlign: 'center',
  height: '38px',
  outline: 'none'
}
const ganttTimePeriodSpan = {
  margin: 'auto'
}

const divCenter = {
  display: 'flex',
  textAlign: 'center'
}

const divCenter1 = {
  display: 'flex',
  textAlign: 'center',
  background: '#F4F6FA',
  marginLeft: '16px',
  marginRight: '16px'
}
